import { showModal } from '@/main_store/modal';

const handleErrors = (error) => {
    console.error('handleErrors:', error)
    if (error.name === 'FirebaseError' && error.code === 'permission-denied') {
        showModal('משתמש חסום. אנא פנה למנהל האפליקציה: volunteering200@gmail.com', 'error')
    } else {
        showModal('ארעה שגיאה. אנא פנה למנהל האפליקציה: volunteering200@gmail.com', 'error')
    }
};

export { handleErrors };
